import { pageContext } from 'ctm-util-functions';

/**
 * @desc Abstracted base builder interface that provides basic constructor and method
 */
class BaseBuilder {

    /**
     * @constructor
     * @desc base constructor that construct shared builder properties
     * @param {Object} schemaModel - the schema model for the builder
     */
    constructor(schemaModel) {
        this.schemaModel = schemaModel;
        this.props = pageContext.getProps();
        this.factory = null;
    }

    /**
     * @desc Abstract build method to guide the concrete builder
     * This is the method gets mapped/exported to the vertical base/model.js to form the builders instances.
     * This method should get the schema from the schema model then pass to the buildComponent()
     */
    build = () => {
        throw new Error('This is an abstract method, you must implement your own "build" method!');
    };

    /**
     * @desc Abstract method to guide the concrete builder
     * This method should call the factory to build a simple component,
     * but before that, it needs to call buildChildren() to build all children components then pass to the factory
     */
    buildComponent = () => {
        throw new Error('This is an abstract method, you must implement your own "buildComponent" method!');
    };

    /**
     * @desc Abstract method to guide the concrete builder
     * This method handles build all children components defined in the schema
     * if the children needs to be built has a mapping, it calls the builder director to be routed
     * it also calls buildComponent() recursively if needed to build children elements defined in the same schema that doesn't need a mapping
     */
    buildChildren = () => {
        throw new Error('This is an abstract method, you must implement your own "buildChildren" method!');
    };

}

export { BaseBuilder };
